export default "__VITE_ASSET__Bhg8iKmm__"